import { Select } from 'antd5';
import styled from 'styled-components';

export const FormFieldContainer = styled.div`
  display: flex;
`;

export const StyledSelect = styled(Select)`
  margin: 0 12px 12px 0;
`;
